import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import GameOverModal from "../../../components/GameOverModal";
import GameWonModal from "../../../components/GameWonModal";
import "../../../assets/css/gamesCss/Array/insertion-deletion2D.css";
import { useLanguage } from "context/LanguageProvider";
import { useDarkMode } from "../../../context/DarkModeProvider";

const InsertionDeletion2D = () => {
    const [currentLevel, setCurrentLevel] = useState(5);
    const [matrix, setMatrix] = useState([]);
    const [lives, setLives] = useState(3);
    const [showGameOver, setShowGameOver] = useState(false);
    const [showGameWon, setShowGameWon] = useState(false);
    const [message, setMessage] = useState("");
    const [userAnswer, setUserAnswer] = useState([]);
    const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);


    useEffect(() => {
        showSuccess && (
            setTimeout(() => setShowSuccess(false), 2000)
        );
    }
    )


    const { selLanguage } = useLanguage();
    const { darkMode } = useDarkMode();

    const levelConfigs = {
        1: {
            initialMatrix: [
                [1, 2, 3, 4],
                [5, 6, 7, 8],
                [9, 10, 11, 12]
            ],
            maxCols: 5,
            challenges: {
                insert: [
                    {
                        id: 1,
                        operation: "insert",
                        element: 99,
                        position: { row: 1, col: 2 },
                        withShift: false,
                        description: selLanguage
                            ? "Εισάγετε το στοιχείο 99 στη θέση [1,2] χωρίς μετατόπιση."
                            : "Insert element 99 at position [1,2] without shifting.",
                        canExecute: true
                    },
                    {
                        id: 2,
                        operation: "insert",
                        element: 50,
                        position: { row: 0, col: 1 },
                        withShift: true,
                        description: selLanguage
                            ? "Εισάγετε το στοιχείο 50 στη θέση [0,1] με μετατόπιση δεξιά."
                            : "Insert element 50 at position [0,1] with right shift.",
                        canExecute: true
                    }
                ],
                delete: [
                    {
                        id: 3,
                        operation: "delete",
                        position: { row: 1, col: 1 },
                        withShift: false,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [1,1] χωρίς μετατόπιση (βάλε - στο κενό κελί)."
                            : "Delete the element at position [1,1] without shifting (put - at the empty shell).",
                        canExecute: true
                    },
                    {
                        id: 4,
                        operation: "delete",
                        position: { row: 0, col: 2 },
                        withShift: true,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [0,2] με μετατόπιση αριστερά."
                            : "Delete the element at position [0,2] with left shift.",
                        canExecute: true
                    }
                ]
            }
        },
        2: {
            initialMatrix: [
                [10, 20, 30, 40],
                [15, 25, 35, 45],
                [12, 22, 32, 42]
            ],
            maxCols: 6,
            challenges: {
                insert: [
                    {
                        id: 5,
                        operation: "insert",
                        element: 18,
                        position: { row: 1, col: 0 },
                        withShift: true,
                        description: selLanguage
                            ? "Εισάγετε το 18 στη θέση [1,0] με μετατόπιση."
                            : "Insert 18 at position [1,0] with shifting.",
                        canExecute: true
                    },
                    {
                        id: 6,
                        operation: "insert",
                        element: 55,
                        position: { row: 2, col: 3 },
                        withShift: false,
                        description: selLanguage
                            ? "Εισάγετε το 55 στη θέση [2,3] χωρίς μετατόπιση."
                            : "Insert 55 at position [2,3] without shifting.",
                        canExecute: true
                    }
                ],
                delete: [
                    {
                        id: 7,
                        operation: "delete",
                        position: { row: 0, col: 1 },
                        withShift: true,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [0,1] με μετατόπιση."
                            : "Delete the element at position [0,1] with shifting.",
                        canExecute: true
                    },
                    {
                        id: 8,
                        operation: "delete",
                        position: { row: 2, col: 2 },
                        withShift: false,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [2,2] χωρίς μετατόπιση."
                            : "Delete the element at position [2,2] without shifting.",
                        canExecute: true
                    }
                ]
            }
        },
        3: {
            initialMatrix: [
                [100, 200, 300],
                [400, 500, 600],
                [700, 800, 900]
            ],
            maxCols: 5,
            challenges: {
                insert: [
                    {
                        id: 9,
                        operation: "insert",
                        element: 777,
                        position: { row: 2, col: 1 },
                        withShift: true,
                        description: selLanguage
                            ? "Εισάγετε το 777 στη θέση [2,1] με μετατόπιση."
                            : "Insert 777 at position [2,1] with shifting.",
                        canExecute: true
                    },
                    {
                        id: 10,
                        operation: "insert",
                        element: 250,
                        position: { row: 0, col: 2 },
                        withShift: false,
                        description: selLanguage
                            ? "Εισάγετε το 250 στη θέση [0,2] χωρίς μετατόπιση."
                            : "Insert 250 at position [0,2] without shifting.",
                        canExecute: true
                    }
                ],
                delete: [
                    {
                        id: 11,
                        operation: "delete",
                        position: { row: 1, col: 1 },
                        withShift: true,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [1,1] με μετατόπιση."
                            : "Delete the element at position [1,1] with shifting.",
                        canExecute: true
                    },
                    {
                        id: 12,
                        operation: "delete",
                        position: { row: 0, col: 0 },
                        withShift: false,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [0,0] χωρίς μετατόπιση."
                            : "Delete the element at position [0,0] without shifting.",
                        canExecute: true
                    }
                ]
            }
        },
        4: {
            initialMatrix: [
                [11, 22, 33, 44],
                [55, 66, 77, 88],
                [99, 100, 110, 120]
            ],
            maxCols: 6,
            challenges: {
                insert: [
                    {

                        id: 21,
                        description: selLanguage
                            ? "Πρώτα εισάγετε το 28 στη θέση [0,2] με μετατόπιση και μετά διαγράψτε το στοιχείο στη θέση [1,1] με μετατόπιση."
                            : "First insert 28 at position [0,2] with shifting, then delete the element at [1,1] with shifting.",
                        steps: [
                            {
                                operation: "insert",
                                element: 28,
                                position: { row: 0, col: 2 },
                                withShift: true,
                                canExecute: true
                            },
                            {
                                operation: "delete",
                                position: { row: 1, col: 1 },
                                withShift: true,
                                canExecute: true
                            }
                        ]
                    }
                ],
                delete: [
                    {
                        id: 15,
                        operation: "delete",
                        position: { row: 1, col: 2 },
                        withShift: true,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [1,2] με μετατόπιση."
                            : "Delete the element at position [1,2] with shifting.",
                        canExecute: true
                    },
                    {
                        id: 16,
                        operation: "delete",
                        position: { row: 0, col: 3 },
                        withShift: false,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [0,3] χωρίς μετατόπιση."
                            : "Delete the element at position [0,3] without shifting.",
                        canExecute: true
                    }
                ]
            }
        },

        5: {
            initialMatrix: [
                [5, 10, 15, 20],
                [25, 30, 35, 40],
                [45, 50, 55, 60],
                [65, 70, 75, 80]
            ],
            maxCols: 6,
            challenges: {
                insert: [

                    {
                        id: 22,
                        description: selLanguage
                            ? "Πρώτα εισάγετε το 12 στη θέση [0,1] με μετατόπιση και μετά διαγράψτε το στοιχείο στη θέση [3,2] χωρίς μετατόπιση (βάλε -)."
                            : "First insert 12 at position [0,1] with shifting, then delete the element at [3,2] without shifting (put -).",
                        steps: [
                            {
                                operation: "insert",
                                element: 12,
                                position: { row: 0, col: 1 },
                                withShift: true,
                                canExecute: true
                            },
                            {
                                operation: "delete",
                                position: { row: 3, col: 2 },
                                withShift: false,
                                canExecute: true
                            }
                        ]
                    }
                ],
                delete: [
                    {
                        id: 19,
                        operation: "delete",
                        position: { row: 1, col: 1 },
                        withShift: true,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [1,1] με μετατόπιση."
                            : "Delete the element at position [1,1] with shifting.",
                        canExecute: true
                    },
                    {
                        id: 20,
                        operation: "delete",
                        position: { row: 3, col: 2 },
                        withShift: false,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση [3,2] χωρίς μετατόπιση."
                            : "Delete the element at position [3,2] without shifting.",
                        canExecute: true
                    }
                ]
            }
        },

    };

    const [currentChallenge, setCurrentChallenge] = useState(null);
    const inputRefs = useRef([]);


    const handleInputKeyDown = (e, rowIdx, colIdx, maxCols, totalRows) => {
        if (e.key !== "Enter") return;

        e.preventDefault();

        const currentIndex = rowIdx * maxCols + colIdx;
        const totalCells = totalRows * maxCols;
        const nextIndex = currentIndex + 1;

        if (nextIndex >= totalCells) return; // δεν υπάρχει επόμενο

        const nextInput = inputRefs.current[nextIndex];
        if (nextInput) {
            nextInput.focus();
            nextInput.select?.();
        }
    };

    const prepareRandomChallengeForLevel = (level) => {
        const levelConfig = levelConfigs[level];
        const allLevelChallenges = [
            ...levelConfig.challenges.insert,
            ...levelConfig.challenges.delete
        ];
        const randomChallenge =
            allLevelChallenges[Math.floor(Math.random() * allLevelChallenges.length)];

        setMatrix(levelConfig.initialMatrix.map(row => [...row]));
        setCurrentChallenge(randomChallenge);
        setUserAnswer([]);
        setShowCorrectAnswer(false);
        setMessage("");
    };

    // Στήσιμο level στην αρχή και κάθε φορά που αλλάζει level ή γλώσσα
    useEffect(() => {
        prepareRandomChallengeForLevel(currentLevel);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLevel, selLanguage]);

    useEffect(() => {
        if (lives <= 0) {
            setShowGameOver(true);
        }
    }, [lives]);

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage("");
                setShowError(false);
                setShowSuccess(false);
            }, 2300);

            return () => clearTimeout(timer);
        }
    }, [message]);

    const executeOperation = (challenge, currentMatrix) => {
        let newMatrix = currentMatrix.map(row => [...row]);
        const { row, col } = challenge.position;

        if (challenge.operation === "insert") {
            if (!challenge.canExecute) {
                return { success: false, matrix: currentMatrix, error: challenge.errorType };
            }

            if (challenge.withShift) {
                if (newMatrix[row].length >= levelConfigs[currentLevel].maxCols) {
                    return {
                        success: false,
                        matrix: currentMatrix,
                        error: selLanguage ? "Δεν χωράει με μετατόπιση!" : "Cannot insert with shifting!"
                    };
                }
                newMatrix[row].splice(col, 0, challenge.element);
            } else {
                newMatrix[row][col] = challenge.element;
            }

            return { success: true, matrix: newMatrix };

        } else if (challenge.operation === "delete") {
            if (!challenge.canExecute) {
                return { success: false, matrix: currentMatrix, error: challenge.errorType };
            }

            if (challenge.withShift) {
                newMatrix[row].splice(col, 1);
            } else {
                newMatrix[row][col] = "_";
            }

            return { success: true, matrix: newMatrix };
        }
    };

    // ---- Helper: σύγκριση πινάκων κελί-κελί ----
    const areMatricesEqual = (a, b) => {
        if (!Array.isArray(a) || !Array.isArray(b)) return false;
        if (a.length !== b.length) return false;

        for (let i = 0; i < a.length; i++) {
            if (!Array.isArray(a[i]) || !Array.isArray(b[i])) return false;
            if (a[i].length !== b[i].length) return false;

            for (let j = 0; j < a[i].length; j++) {
                if (a[i][j] !== b[i][j]) return false;
            }
        }
        return true;
    };

    // ---- Helper: φτιάχνω πλήρη user matrix από την απάντηση ----
    // Κενά κελιά => παίρνουν την αρχική τιμή από τον αρχικό πίνακα
    const buildUserMatrix = (expectedMatrix) => {
        return expectedMatrix.map((row, rIdx) =>
            row.map((_, cIdx) => {
                const uaRow = userAnswer[rIdx];
                const uaVal = uaRow ? uaRow[cIdx] : undefined;

                if (uaVal !== undefined && uaVal !== "") {
                    return uaVal;
                }

                const initialRow = matrix[rIdx];
                return initialRow ? initialRow[cIdx] : undefined;
            })
        );
    };

    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const handleSuccess = () => {
        if (currentLevel < 5) {
            setTimeout(() => {
                setCurrentLevel(prev => prev + 1);
            }, 2000);
        } else {
            setShowGameWon(true);
        }
    };

    const handleFailure = () => {
        const newLives = lives - 1;
        setLives(newLives);

        if (newLives <= 0) {
            setShowGameOver(true);
        } else {
            setTimeout(() => {
                prepareRandomChallengeForLevel(currentLevel);
            }, 3000);
        }
    };

    const handleUserSubmit = () => {

        if (userAnswer.length === 0 && currentChallenge.canExecute) {
            setMessage(selLanguage ? " Παρακαλώ εισάγετε την απάντησή σας!" : " Please enter your answer!");
            setShowError(true);
            handleFailure();
            return;
        }

        const result = executeOperation(currentChallenge, matrix);

        if (!currentChallenge.canExecute) {
            // δεν έχεις τέτοια challenges αυτή τη στιγμή, το κρατάω για μελλοντική χρήση
            if (userAnswer.length === 0 || areMatricesEqual(buildUserMatrix(result.matrix), matrix)) {
                setMessage(selLanguage ? " Σωστό! Συνέχισε έτσι!" : " Correct! Keep it up!");
                setShowSuccess(true);
                handleSuccess();
            } else {
                setMessage(selLanguage ? " Λάθος! Δεν πειράζει, συνέχισε την καλή προσπάθεια!" : " Wrong! No worries, keep up the good effort!");
                setShowError(true);
                setShowCorrectAnswer(true);
                handleFailure();
            }
        } else {
            const expectedMatrix = result.matrix;
            const userMatrix = buildUserMatrix(expectedMatrix);

            if (areMatricesEqual(userMatrix, expectedMatrix)) {
                setMessage(selLanguage ? " Μπράβο! Σωστή απάντηση!" : " Well done! Correct answer!");
                setShowSuccess(true);
                handleSuccess();
            } else {
                setMessage(selLanguage ? " Λάθος απάντηση! Συνέχισε την προσπάθεια!" : " Wrong answer! Keep trying!");
                setShowError(true);
                setShowCorrectAnswer(true);
                handleFailure();
            }
        }
    };

    const handleMatrixInput = (rowIdx, colIdx, value) => {
        const rows = matrix.length;
        const cols = Math.max(...matrix.map(r => r.length));
        const newAnswer = userAnswer.map(row => [...row]);

        if (newAnswer.length === 0) {
            for (let r = 0; r < rows; r++) {
                newAnswer.push(Array(cols).fill(""));
            }
        }

        newAnswer[rowIdx][colIdx] =
            value === "" ? "" : (isNaN(value) ? "_" : parseInt(value));

        setUserAnswer(newAnswer);
    };

    const resetGame = () => {
        setShowError(false);
        setShowSuccess(false);
        setMessage("");
        setLives(3);
        setShowGameOver(false);
        setShowGameWon(false);
        setCurrentLevel(1);
        // αναγκαστική ανανέωση challenge για level 1
        prepareRandomChallengeForLevel(1);
    };

    const getCorrectAnswer = () => {
        const result = executeOperation(currentChallenge, matrix);
        return result.success ? result.matrix : matrix;
    };

    const renderMatrix = (matrixData, title, isUserInput = false) => {
        const maxCols = Math.max(
            ...matrixData.map(row => row.length),
            levelConfigs[currentLevel].maxCols
        );

        if (isUserInput) {
            inputRefs.current = [];
        }

        return (
            <div style={{ marginBottom: "30px" }}>
                <h4 style={{
                    color: darkMode ? "#f1f5f9:" : "#131212ff",
                    marginBottom: "15px",
                    fontSize: "1.2em",
                    textAlign: "center",
                    fontWeight: "700"
                }}>
                    {title}
                </h4>
                <div style={{
                    background: isUserInput ? "rgba(59, 130, 246, 0.1)" : "rgba(255, 255, 255, 0.05)",
                    borderRadius: "16px",
                    padding: "20px",
                    border: isUserInput ? "2px dashed #3b82f6" : "2px solid rgba(255, 255, 255, 0.1)"
                }}>
                    <div style={{ display: "flex", marginBottom: "10px", marginLeft: "60px", justifyContent: "center" }}>
                        {Array.from({ length: maxCols }).map((_, colIdx) => (
                            <div
                                key={`col-header-${colIdx}`}
                                style={{
                                    width: "70px",
                                    marginRight: "8px",
                                    textAlign: "center",
                                    fontWeight: "700",
                                    fontSize: "0.9rem",
                                    color: "#3b82f6"
                                }}
                            >
                                {colIdx}
                            </div>
                        ))}
                    </div>

                    {matrixData.map((row, rowIdx) => (
                        <div key={`row-${rowIdx}`} style={{ display: "flex", alignItems: "center", marginBottom: "8px", justifyContent: "center" }}>
                            <div style={{
                                width: "50px",
                                textAlign: "center",
                                fontWeight: "700",
                                fontSize: "0.9rem",
                                color: "#3b82f6",
                                marginRight: "10px"
                            }}>
                                {rowIdx}
                            </div>

                            <div style={{ display: "flex", gap: "8px" }}>
                                {Array.from({ length: maxCols }).map((_, colIdx) => {
                                    const value = row[colIdx];
                                    const userValue = isUserInput && userAnswer[rowIdx] ? userAnswer[rowIdx][colIdx] : undefined;

                                    return isUserInput ? (
                                        <input
                                            key={`input-${rowIdx}-${colIdx}`}
                                            type="text"
                                            value={userValue !== undefined ? userValue : ""}
                                            onChange={(e) => handleMatrixInput(rowIdx, colIdx, e.target.value)}
                                            placeholder="?"
                                            ref={el => {
                                                if (el) {
                                                    inputRefs.current[rowIdx * maxCols + colIdx] = el;
                                                }
                                            }}
                                            onKeyDown={(e) =>
                                                handleInputKeyDown(
                                                    e,
                                                    rowIdx,
                                                    colIdx,
                                                    maxCols,
                                                    matrixData.length
                                                )
                                            }
                                            style={{
                                                width: "70px",
                                                height: "70px",
                                                textAlign: "center",
                                                border: "2px solid #475569",
                                                borderRadius: "10px",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                background: userValue !== undefined && userValue !== ""
                                                    ? "rgba(59, 130, 246, 0.2)"
                                                    : "rgba(15, 23, 42, 0.6)",
                                                color: "white"
                                            }}
                                        />
                                    ) : (
                                        <motion.div
                                            key={`cell-${rowIdx}-${colIdx}-${value}`}
                                            initial={{ scale: 0.8, opacity: 0 }}
                                            animate={{ scale: 1, opacity: 1 }}
                                            transition={{ delay: (rowIdx * maxCols + colIdx) * 0.05 }}
                                            style={{
                                                width: "70px",
                                                height: "70px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "1.1rem",
                                                fontWeight: "700",
                                                color: "white",
                                                background: value === undefined
                                                    ? "rgba(107, 114, 128, 0.3)"
                                                    : value === "_"
                                                        ? "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)"
                                                        : "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                                                borderRadius: "10px",
                                                boxShadow: value !== undefined && value !== "_"
                                                    ? "0 4px 12px rgba(59, 130, 246, 0.3)"
                                                    : "none",
                                                border: value === undefined ? "2px dashed #475569" : "none"
                                            }}
                                        >
                                            {value !== undefined ? value : ""}
                                        </motion.div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    if (!currentChallenge) {
        return <div>{selLanguage ? "Φόρτωση..." : "Loading..."}</div>;
    }

    return (
        <div className="main-content introDirectedContainer m"
            style={{
                background: darkMode ? "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #101724ff 100%)" : "var(--lightModeGameBackground)"
            }}>
            <GameOverModal isVisible={showGameOver} onPlayAgain={resetGame} />
            <GameWonModal isVisible={showGameWon} onPlayAgain={resetGame} />

            <div style={{ width: "100%", maxWidth: "1100px" }}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                    width: "100%"
                }}>
                    <div style={{
                        color: darkMode ? "#fff" : "#1a1919ff",
                        padding: "12px 24px",
                        borderRadius: "12px",
                        fontWeight: "700",
                        fontSize: "18px",
                        border: darkMode ? "2px solid rgba(255, 255, 255, 0.2)" : "1px solid #131111ff",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px"
                    }}>
                        {selLanguage ? `Επίπεδο ${currentLevel}/5` : `Level ${currentLevel}/5`}
                    </div>

                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px"
                    }}>
                        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                            {[1, 2, 3].map((heartNum) => (
                                <div
                                    key={heartNum}
                                    style={{
                                        fontSize: "24px",
                                        filter: lives >= heartNum
                                            ? "drop-shadow(0 4px 8px rgba(220, 38, 38, 0.4))"
                                            : "grayscale(100%) opacity(0.3)",
                                        transform: lives >= heartNum ? "scale(1)" : "scale(0.8)",
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    ❤️
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div style={{
                    borderRadius: "20px",
                    background: "linear-gradient(135deg, rgba(59, 130, 246, 0.4), rgba(29, 78, 216, 0.4))",
                    padding: "15px 20px",
                    marginBottom: "20px",
                    color: "white",
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: "1.05rem"
                }}>
                    {currentChallenge.description}
                </div>

                <div style={{
                    background: darkMode ? "rgba(15, 23, 42, 0.6)" : "#fff",
                    borderRadius: "20px",
                    padding: "30px",
                    marginBottom: "20px"
                }}>
                    {renderMatrix(matrix, selLanguage ? "Αρχικός Πίνακας" : "Initial Matrix")}
                    {renderMatrix(
                        userAnswer.length > 0 ? userAnswer : matrix.map(row => row.map(() => "")),
                        selLanguage ? "Η Απάντησή σας" : "Your Answer",
                        true
                    )}
                    {/*} {showCorrectAnswer && (
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                        >
                            {renderMatrix(getCorrectAnswer(), selLanguage ? "Σωστή Απάντηση" : "Correct Answer")}
                        </motion.div>
                    )} */}
                </div>

                {showError && (
                    <motion.div
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        style={{
                            background: '#fee2e2',
                            borderRadius: '15px',
                            padding: '20px',
                            marginBottom: '20px',
                            border: '2px solid #dc2626',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: "95%"
                        }}
                    >
                        <p style={{ color: '#991b1b', margin: 0 }}>
                            {message}
                        </p>
                    </motion.div>
                )}

                {showSuccess && (
                    <motion.div
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        style={{
                            background: '#d1fae5',
                            borderRadius: '15px',
                            padding: '20px',
                            marginBottom: '20px',
                            border: '2px solid #10b981',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: "95%"
                        }}
                    >
                        <p style={{ color: '#065f46', margin: 0 }}>
                            {currentLevel < 5
                                ? (selLanguage
                                    ? "Συγχαρητήρια! Προχωράς στο επόμενο επίπεδο!"
                                    : "Congratulations! You are advancing to the next level!")
                                : (selLanguage
                                    ? "Συγχαρητήρια! Ολοκλήρωσες όλα τα επίπεδα!"
                                    : "Congratulations! You completed all levels!")
                            }
                        </p>
                    </motion.div>
                )}

                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "20px",
                    flexWrap: "wrap"
                }}>
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={handleUserSubmit}
                        style={{
                            background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                            color: "white",
                            border: "none",
                            borderRadius: "16px",
                            padding: "14px 28px",
                            fontSize: "1rem",
                            fontWeight: 600,
                            cursor: "pointer",
                            boxShadow: "0 10px 25px rgba(31, 18, 219, 0.3)"
                        }}
                    >
                        {selLanguage ? "Υποβολή Απάντησης" : "Submit Answer"}
                    </motion.button>

                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={resetGame}
                        style={{
                            background: "linear-gradient(135deg, #b81e1eff 0%, #7c0505ff 100%)",
                            color: "white",
                            border: "none",
                            borderRadius: "16px",
                            padding: "14px 28px",
                            fontSize: "1rem",
                            fontWeight: 600,
                            cursor: "pointer",
                            boxShadow: "0 10px 25px rgba(184, 30, 30, 0.3)"
                        }}
                    >
                        {selLanguage ? "Επανεκκίνηση" : "Restart Game"}
                    </motion.button>
                </div>
            </div>
        </div>
    );
};

export default InsertionDeletion2D;
